import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Gift, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const ReferralBanner = () => {
  const navigate = useNavigate();

  return (
    <Card className="clean-card gradient-purple text-white overflow-hidden relative">
      <CardContent className="p-6">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-white/10 rounded-lg">
            <Gift className="h-8 w-8" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold mb-1">Earn with Referrals</h3>
            <p className="text-white/90 text-sm mb-3">
              Get 1% of your referrals' spending for their first 3 months!
            </p>
            <Button 
              variant="secondary"
              size="sm"
              className="rounded-full"
              onClick={() => navigate('/profile?tab=referrals')}
            >
              <TrendingUp className="h-4 w-4 mr-2" />
              Start Referring
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
